import * as React from 'react';

/* import Alert from './components/Alert'; */
import Button from '../common/Button';
import Alert from 'src/components/common/Alert';
import Loader from './../common/Loader';

import './UserUpdateInfo.scss';
import UserModel from 'src/model/user.model';
import { red } from 'color-name';
import { deprecate } from 'util';

interface IUserUpdateInfoComponentProps {
  updateUserInfo(email: string, phone: string): void;
  signout(): void;
  pending: boolean;
  error: { hasFailed: boolean; message: string };
  userData: UserModel;
  t: any;
  emailUpdated: any;
}

interface IUserUpdateInfoComponentState {
  email: string;
  phone: string;
  errorAlert: boolean;
  successAlert: boolean;
}

class UserUpdateInfoComponent extends React.Component<
  IUserUpdateInfoComponentProps,
  IUserUpdateInfoComponentState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      email: this.props.userData?.email ? this.props.userData.email : '',
      phone: this.props.userData?.mobileNumber
        ? this.props.userData.mobileNumber
        : '',
      errorAlert: false,
      successAlert: false
    };
  }

  private handleEmail = (event: any) => {
    this.setState({ email: event.target.value });
  };

  private handlePhone = (event: any) => {
    this.setState({ phone: event.target.value });
  };

  private updateInfo = () => {
    this.setState(
      {
        errorAlert: false,
        successAlert: false
      },
      () => {
        this.props.updateUserInfo(
          this.state.email.toLowerCase(),
          this.state.phone
        );
      }
    );
  };

  private handleCloseError = () => {
    this.setState({ errorAlert: false });
  };

  private handleEnterToSubmit = (event: any) => {
    if (event.key === 'Enter') {
      this.updateInfo();
    }
  };

  public componentDidUpdate(prevProps: IUserUpdateInfoComponentProps) {
    if (this.props.userData !== prevProps.userData) {
      this.setState({
        email: this.props.userData.email,
        phone: this.props.userData.mobileNumber
      });
    }
    if (this.props.emailUpdated !== prevProps.emailUpdated) {
      this.setState({ successAlert: this.props.emailUpdated?.isEmailUpdated });
    }
    if (this.props.error !== prevProps.error) {
      this.setState({ errorAlert: this.props.error.hasFailed });
    }
  }

  public handleCloseSucess = () => {
    this.setState({ successAlert: false });
  };

  private renderHeader = (t: any) => {
    if (
      this.props.emailUpdated?.isEmailUpdated &&
      this.state.successAlert &&
      !this.props.error.hasFailed
    ) {
      return (
        <Alert
          type="success"
          styleClass="rp-user-update-info--error-alert"
          icon={'icon="rpds-check-circle"'}
          handleCloseAlert={this.handleCloseSucess}
          message={t('accountManagePassword.successUpdatedMessage')}
        />
      );
    }
    switch (this.props.error.hasFailed && this.state.errorAlert) {
      default:
      case false:
        return (
          <React.Fragment>
            <p className="title h1">{t('login.updateInfo')}</p>
            <span className={'subtitle'}>
              {t('accountManagePassword.verifyWarning', {
                interpolation: { escapeValue: false }
              })}
            </span>
          </React.Fragment>
        );
      case true:
        const message = this.props.error.message.split('-');
        let targetMessage = '';
        if (message.length === 2) {
          targetMessage = `\u2022 ${this.getMessage(message[0])} \r\n
          \u2022 ${this.getMessage(message[1])}`;
        } else {
          targetMessage = this.getMessage(message[0]);
        }
        return (
          <Alert
            type="error"
            styleClass="rp-user-update-info--error-alert pre-line-white-space"
            icon={'rpds-error'}
            handleCloseAlert={this.handleCloseError}
            message={targetMessage}
          />
        );
    }
  };

  private getMessage = (message: string): string => {
    const { t } = this.props;
    if (message?.toLowerCase()?.includes('phone')) {
      return t('accountManagePassword.invalidPhoneNumber');
    } else if (message?.toLowerCase()?.includes('email')) {
      return t('accountManagePassword.invalidEmail');
    }
    return message;
  };

  public render() {
    const { t } = this.props;

    return (
      <div className="rp-user-update-info--container">
        {this.props.pending ? <Loader /> : null}
        {/* Component container ^ */}
        {/* Component header v*/}
        <div className="rp-user-update-info--header">
          {this.renderHeader(t)}
        </div>
        {/* Component content */}
        <div className="rp-user-update-info--content">
          <form className="rp-user-update-info--form">
            <label className="form--label h4" htmlFor="email">
              {t('common.email')}:
            </label>
            <input
              className="form--text-input"
              type="text"
              name="email"
              value={this.state.email}
              onChange={this.handleEmail}
              tabIndex={1}
            />
            {/* <a className="form--link" href="javascript:void(0)" onClick={goToForgotUser}>
              {t("login.forgotUserId")}
            </a> */}
            <label className="form--label h4" htmlFor="phone">
              {t('common.cellphone')}:{' '}
              {`(ex. 9999999999, ${t('common.noDashes')})`}
            </label>
            <input
              className="form--text-input"
              type="phone"
              value={this.state.phone}
              onChange={this.handlePhone}
              onKeyPress={this.handleEnterToSubmit}
              tabIndex={2}
            />
            <div className="form--rp-user-update-info">
              <Button
                buttonClass="primary-button form--update-button"
                label={t('common.update')}
                height="48px"
                width="100%"
                action={this.updateInfo}
                disabled={!this.state.email && !this.state.phone}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default UserUpdateInfoComponent;
